import React from 'react';
import { defaultTemplate } from 'core/hoc';
import _ from 'lodash';
import { BaasicButton, BaasicHeader } from 'core/components';
import { observer } from 'mobx-react';
import { isSome } from 'core/utils';
import { formatDate } from 'core/utils';
import { ScheduledJobLogList } from 'modules/alerts/pages';

const AlertsTemplate = ({ viewStore, t }) => {
	return (
		<React.Fragment>
			<BaasicHeader title="Alerts"></BaasicHeader>

			<div className="alerts-page__wrap">
				{/* --- PROCESSING SECTION --- */}
				<div className="alerts-page__processing">
					<div className="alerts-page__processing-header">Processing Now</div>

					<div className="alerts-page__processing-body">
						{viewStore.activeJobsWithEstimates && viewStore.activeJobsWithEstimates.length > 0 ? (
							_.map(viewStore.activeJobsWithEstimates, (job, i) => (
								<div key={i} className="processing-item">
									<div className="flex--primary flex--between spc--bottom--sm">
										<div className="spinner-inline-small"></div>
										<strong className="spc--left--sml">{job.jobTitle}</strong>
										<span className="text-muted spc--left--med">Started: {formatDate(job.startedAt, true, 'LLL')}</span>
										<span className="text-muted spc--left--med">Est. Finish: {job.estimatedFinishTime}</span>
									</div>
								</div>
							))
						) : (
							<div className="processing-empty">No active jobs running.</div>
						)}
					</div>
				</div>

				{/* --- HISTORY TABLE --- */}
				<div className="alerts-page__table-section">
					<ScheduledJobLogList
						viewStore={viewStore}
					/>
				</div>
			</div>
		</React.Fragment>
	);
};

export default defaultTemplate(AlertsTemplate);
